

export const BaseURL = process.env.NODE_ENV === 'production' ? 'https://webbackend.dispurcollege.ac.in/public' : 'http://localhost/dispur-website-new/api/public';
export const WebURL = 'https://backend.dispurcollege.ac.in/public';
//export const WebURL = 'http://localhost/dispur-college/api/public';

export function PostData(type, userData) {

    return new Promise((resolve, reject) => {
        fetch(BaseURL + type, {
            method: 'POST',
            body: JSON.stringify(userData),
            headers: {
                'Content-Type': 'application/json',
                'Unit': 'website'
            }
        })
            .then((resp) => {
                if (!resp.ok) {
                    throw resp.text();
                } else {
                    return resp.json();
                }
            })
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                console.log(error)
                reject(error);
            });
    });
}





export function PostDataExtra(type, userData) {

    return new Promise((resolve, reject) => {
        fetch(WebURL + type, {
            method: 'POST',
            body: JSON.stringify(userData),
            headers: {
                'Content-Type': 'application/json',
                'Unit': 'website'
            }
        })
            .then((resp) => {
                if (!resp.ok) {
                    throw resp.text();
                } else {
                    return resp.json();
                }
            })
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                console.log(error)
                reject(error);
            });
    });
}

export function GetData(type) {


    return new Promise((resolve, reject) => {
        fetch(BaseURL + type, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Unit': 'website'
            }
        })
            .then((resp) => {
                if (!resp.ok) {

                    throw resp.text();

                } else {
                    return resp.json();
                }
            })
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                console.log(error)
                reject(error);
            });
    });
}



export function GetDataExtra(type) {

    return new Promise((resolve, reject) => {
        fetch(WebURL + type, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Unit': 'website'
            }
        })
            .then((resp) => {
                if (!resp.ok) {
                    throw resp.text();
                } else {
                    return resp.json();
                }
            })
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                console.log(error)
                reject(error);
            });
    });
}